var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c("div", { staticClass: "column-layout clearfix" }, [
        _c("div", { staticClass: "left-column fl" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fixed-tree",
              staticStyle: { height: "445px" },
              attrs: { id: "tree-menu" }
            },
            [
              _c("swb-goods-categ-tree", {
                attrs: { noPostFilters: true, enableSearch: true },
                on: {
                  "notity-change": function($event) {
                    _vm.notityChange($event)
                  }
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "right-column fl"
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "background-color": "#fafafa",
                  "line-height": "49px",
                  height: "49px"
                }
              },
              [
                _c("span", { staticClass: "ml15" }, [
                  _vm._v("当前分类：【"),
                  _vm.thisCatInfo.id != null
                    ? _c("span", { staticClass: "font-red" }, [
                        _vm._v(_vm._s(_vm.thisCatInfo.name))
                      ])
                    : _c("span", [_vm._v("无")]),
                  _vm._v("】"),
                  _vm.showDesc && _vm.thisCatInfo.desc != null
                    ? _c("span", { staticClass: "font-gray2" }, [
                        _vm._v(" (" + _vm._s(_vm.thisCatInfo.desc) + ")")
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.thisCatInfo.id != null &&
                _vm.thisCatInfo.level < 3 &&
                !_vm.readOnly
                  ? _c(
                      "button",
                      {
                        staticClass: "swb-btn swb-btn-small mr15",
                        staticStyle: { float: "right", "margin-top": "8px" },
                        on: {
                          click: function($event) {
                            _vm.saveRoleGoodsCat()
                          }
                        }
                      },
                      [_c("span", [_vm._v("保存")])]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-layout" }, [
              _c(
                "ul",
                {
                  staticClass: "switch-list clearfix ml10",
                  staticStyle: { "margin-top": "20px" }
                },
                [
                  _vm.thisCatInfo.id != null && _vm.thisCatInfo.level < 3
                    ? _c(
                        "el-checkbox-group",
                        {
                          on: {
                            change: function($event) {
                              _vm.checkParentChange(_vm.thisCatInfo)
                            }
                          },
                          model: {
                            value: _vm.thisCatInfo.allSelected,
                            callback: function($$v) {
                              _vm.$set(_vm.thisCatInfo, "allSelected", $$v)
                            },
                            expression: "thisCatInfo.allSelected"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                disabled: _vm.thisDisabled || _vm.readOnly,
                                label: _vm.thisCatInfo.id
                              }
                            },
                            [_vm._v("所有下级")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.goodsCatList.length > 0
                    ? _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.roleGoodsCatIds,
                            callback: function($$v) {
                              _vm.roleGoodsCatIds = $$v
                            },
                            expression: "roleGoodsCatIds"
                          }
                        },
                        _vm._l(_vm.goodsCatList, function(goodsCat) {
                          return _c(
                            "li",
                            {
                              staticClass: "switch-item ellipsis-1",
                              staticStyle: {
                                width: "auto",
                                "margin-right": "30px"
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    label: goodsCat.id,
                                    disabled:
                                      _vm.thisCatInfo.allSelected ||
                                      _vm.thisDisabled ||
                                      _vm.readOnly
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(goodsCat.name)),
                                    _vm.showDesc && goodsCat.desc != null
                                      ? _c(
                                          "span",
                                          { staticClass: "font-gray2" },
                                          [
                                            _vm._v(
                                              " (" + _vm._s(goodsCat.desc) + ")"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        })
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.goodsCatList == null || _vm.goodsCatList.length <= 0
                ? _c(
                    "ul",
                    {
                      staticClass: "switch-list clearfix ml10",
                      staticStyle: { "margin-top": "50px" }
                    },
                    [_vm._m(1)]
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-container base" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c("ul", { staticClass: "head" }, [
          _c("li", { staticClass: "head-item current" }, [_vm._v("商品分类")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      {
        staticClass: "switch-item ellipsis-1",
        staticStyle: { width: "auto", "margin-right": "30px" }
      },
      [_c("span", [_vm._v("当前分类没有子项")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f3b08f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f3b08f9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/ComRoleGoodsCat.vue
// module id = 3409
// module chunks = 0